// test1233
(1233 && 0);
